import {difference, findKey, forEach, get, has, isArray, isEmpty, isPlainObject, isString, set} from 'lodash';
import {snakeCase} from '~/utils/helpers/string';
import {parse} from 'querystring';
import {AdminEntity, AdminRole} from '~/types/models/admin';
import moment from '~/services/moment';
// import {ROLE_ADMIN, ROLE_OPERATION, ROLE_SUPER_ADMIN} from '~/constants';
import config from '~/config/app-config';

export function snakeCaseObj(obj: Record<string, any>, removeWhitespace = true) {
  if (!isPlainObject(obj)) {
    return obj;
  }
  const res: Record<string, any> = {};
  Object.keys(obj).forEach(property => {
    let value = obj[property];
    if (isArray(value)) {
      value = value.map(item => snakeCaseObj(item));
    } else if (isPlainObject(value)) {
      value = snakeCaseObj(value);
    }
    if (removeWhitespace) {
      if (isString(value)) {
        value = value.replace(/\\t$/, '').trim();
      }
    }
    res[snakeCase(property)] = value;
  });

  return res;
}

export function parseFormDataToObj(formData: FormData) {
  const object: Record<string, any> = {};
  // @ts-ignore
  for (const [key, value] of formData.entries()) {
    if (!(value instanceof File)) {
      object[key] = value;
    }
  }
  return object;
}

export function serializeQueryString(obj: Record<string, any>, {encode = true, snakeKey = false} = {}) {
  if (!obj) {
    return '';
  }
  return `?${Object.keys(obj)
    .reduce((a, k) => {
      if (Array.isArray(obj[k]) && obj[k].length > 0) {
        obj[k].forEach((val: any) => {
          const key = snakeKey ? snakeCase(k) : k;
          let value = val;
          if (isString(value)) {
            value = value.replace(/\\t$/, '').trim();
          }
          value = encode ? encodeURIComponent(value) : value;

          // @ts-ignore
          a.push(`${key}[]=${value}`);
        });
      } else if (obj[k] !== null && obj[k] !== undefined) {
        const key = snakeKey ? snakeCase(k) : k;
        let value = obj[k];
        if (isString(value)) {
          value = value.replace(/\\t$/, '').trim();
        }
        value = encode ? encodeURIComponent(value) : value;
        // @ts-ignore
        a.push(`${key}=${value}`);
      }
      return a;
    }, [])
    .join('&')}`;
}

export function findValuePath(obj: object, needle = 'default'): string[] {
  const matchKey = findKey(obj, v => v === needle);
  if (matchKey) {
    return [matchKey];
  }
  const res: string[] = [];
  forEach(obj, (v, k) => {
    if (typeof v === 'object') {
      const valuePath = findValuePath(v, needle);
      if (valuePath.length) {
        res.push(...(isArray(valuePath) ? valuePath : [valuePath]), k);
      }
    }
  });
  return res;
}

export function ensureSafeChaining(object: Object, path: string | string[], defaultValue?: any) {
  // Ensure the path is existed first
  if (!has(object, path)) {
    set(object, path, undefined);
  }
  // Set default value if you want to. (defaultValue !== undefined)
  if (defaultValue !== undefined && get(object, path) === undefined) {
    set(object, path, defaultValue);
  }
}

export function firstObjValue(obj: Record<any, any>) {
  // eslint-disable-next-line no-restricted-syntax
  for (const k in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(k)) {
      return obj[k];
    }
  }
  return undefined;
}

export function getObjNthItem(obj: Record<any, any>, nth: number) {
  if (!obj) {
    return undefined;
  }
  const index = nth - 1;
  const objKeys = Object.keys(obj);
  const targetKey = objKeys && objKeys[index];
  return obj[targetKey];
}

export const move = (array: any[], fromIndex: number, toIndex: number) => {
  const cloneArray = [...array];
  cloneArray.splice(toIndex, 0, cloneArray.splice(fromIndex, 1)[0]);
  return cloneArray;
};

export const getPageQuery = () => parse(window.location.href.split('?')[1]);

export const checkPermissions = (authorities: AdminRole[] = [], permissions: string[] = []) => {
  return true;
  // if (isEmpty(permissions)) {
  //   return true;
  // }
  // if (authorities.some(a => a.value === ROLE_SUPER_ADMIN)) {
  //   return true;
  // }
  // const rolesCanNotAccess = difference(
  //   authorities.map(r => r.value),
  //   permissions,
  // );
  // return rolesCanNotAccess.length < authorities.length;
};

/**
 * Changes the month, year, and date of a given date string to match another date string.
 * @param currentValue - The current date string to modify.
 * @param toValue - The target date string to match.
 * @returns A formatted date string with the modified month, year, and date.
 */
export const changeDateMonthYear = (currentValue?: string, toValue?: string) => {
  let currentValueMoment = moment(currentValue);
  let toValueMoment = moment(toValue);
  currentValueMoment.date(toValueMoment.date());
  currentValueMoment.month(toValueMoment.month());
  currentValueMoment.year(toValueMoment.year());
  return moment(currentValueMoment).format();
};

const pharmacyDispensationDeliveryTypeColor = ['#5553B2', 'baseColor', 'fadedJade', '#F94747', '#5553B2'];
export const getPharmacyDispensationDeliveryTypeColor = (index: number) => {
  const colorIdx = index % pharmacyDispensationDeliveryTypeColor.length;
  return pharmacyDispensationDeliveryTypeColor[colorIdx];
};

// export const checkAdminOrOps = (user?: AdminEntity) => {
//   if (!user) return;
//   return checkPermissions(user?.roles || [], [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_OPERATION]);
// };

// export const checkSuperAdmin = (user?: AdminEntity) => {
//   if (!user) return;
//   return checkPermissions(user?.roles || [], [ROLE_SUPER_ADMIN]);
// };

export const randomColor = () => Math.floor(Math.random() * 16777215).toString(16);

export const generateCSVLink = (queryParams: any, endpoint: string, token: string) => {
  const timezoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const params = new URLSearchParams(queryParams);
  params.delete('page'); // BE dont need page param
  const url = new URL(`${config.api.url}${endpoint}?timezone-id=${timezoneId}&${params.toString()}&token=${token}`);
  return url;
};

/**
 * Redirects the current page to the specified URL within an iframe, or opens it in a new window if the current page is not within an iframe.
 * @param url - The URL to redirect to.
 * @param target - The target window or frame for the URL. Defaults to '_blank'.
 */
export const redirectInIframe = (url: string, target: string = '_blank') => {
  if (window.top) {
    window.top.location.href = url;
  } else {
    window.open(url, target);
  }
};

/**
 * Checks if a given date string represents a person who is under 18 years old.
 * @param date - The date string to check.
 * @returns A boolean indicating whether the person is under 18 years old.
 */
export const isUnderAge = (date?: string) => {
  if (!date) {
    return true;
  }
  return moment().diff(date, 'years') < 18;
};

/**
 * Triggers a chat from the iframe by sending a postMessage to the parent window.
 */
export const triggerChat = () => {
  const postMessage: {
    func: string;
    message: string;
    type?: number;
    key?: string;
  } = {
    func: 'triggerChat',
    message: 'Trigger chat from iframe.',
    key: 'show_freshchat',
  };
  if (window.parent) {
    window.parent.postMessage(postMessage, '*');
  }
};

export const isBase64 = (str: string) => {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
};
